import { render, staticRenderFns } from "./CanShowChart.vue?vue&type=template&id=bfe0e9d2&"
import script from "./CanShowChart.vue?vue&type=script&lang=js&"
export * from "./CanShowChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfe0e9d2')) {
      api.createRecord('bfe0e9d2', component.options)
    } else {
      api.reload('bfe0e9d2', component.options)
    }
    module.hot.accept("./CanShowChart.vue?vue&type=template&id=bfe0e9d2&", function () {
      api.rerender('bfe0e9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Charts/CanShowChart.vue"
export default component.exports